import React from "react";

export function Profile() {
    return (
        <main className="mx-auto container min-h-screen flex items-center">
            <div>
                <h1 className="text-6xl">My Profile</h1>
                <a className="text-blue-500" href="/">Go Home</a>
            </div>
        </main>
    )
}